var $33cfa09ef571f07f$exports = {};
const $33cfa09ef571f07f$var$infoGraphicOpenBtn = document.querySelectorAll(".js-modal-open-btn");
const $33cfa09ef571f07f$var$infoGraphicModals = document.querySelectorAll(".info-graphic__diagram-modal");
const $33cfa09ef571f07f$var$infoGraphicModalWrap = document.querySelector(".info-graphic__diagram-modal-wrap");
const $33cfa09ef571f07f$var$infoGraphicModalClose = document.querySelectorAll(".info-graphic__diagram-modal__close");
let $33cfa09ef571f07f$var$isValid = false;
for(let i = 0; i < $33cfa09ef571f07f$var$infoGraphicOpenBtn.length; i++){
    $33cfa09ef571f07f$var$infoGraphicOpenBtn[i].addEventListener("click", ()=>{
        if ($33cfa09ef571f07f$var$isValid) {
            $33cfa09ef571f07f$var$infoGraphicModalWrap.classList.add("is-open");
            $33cfa09ef571f07f$var$infoGraphicModals[i].classList.add("is-open");
        }
    });
    $33cfa09ef571f07f$var$infoGraphicModalClose[i].addEventListener("click", ()=>{
        if ($33cfa09ef571f07f$var$isValid) {
            $33cfa09ef571f07f$var$infoGraphicModalWrap.classList.remove("is-open");
            $33cfa09ef571f07f$var$infoGraphicModals[i].classList.remove("is-open");
        }
    });
    $33cfa09ef571f07f$var$infoGraphicModalWrap.addEventListener("click", (e)=>{
        if ($33cfa09ef571f07f$var$isValid) {
            $33cfa09ef571f07f$var$infoGraphicModalWrap.classList.remove("is-open");
            $33cfa09ef571f07f$var$infoGraphicModals[i].classList.remove("is-open");
        }
    });
    $33cfa09ef571f07f$var$infoGraphicModals[i].addEventListener("click", (e)=>{
        e.stopPropagation();
    });
}
function $33cfa09ef571f07f$var$checkWindowSize() {
    if (window.innerWidth > 1024) $33cfa09ef571f07f$var$isValid = false;
    else $33cfa09ef571f07f$var$isValid = true;
}
window.addEventListener("resize", $33cfa09ef571f07f$var$checkWindowSize);
$33cfa09ef571f07f$var$checkWindowSize();


//# sourceMappingURL=index.ffd912dc.js.map
